import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <div style={{float:'center'}}>
            <br/><br/>
            <a href="https://www.linkedin.com/in/curtisfell/">
               <img src="http://www.linkedin.com/img/webpromo/btn_profile_greytxt_80x15.png" width="80" height="15" border="1" alt="View Curtis Fell's profile on LinkedIn"/>
            </a>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js